import { onMounted, ref } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { GET_LOCATION_BASED_FACTOR_TYPES } from '../helpers/apiURLS'
import { fetchApiData } from '../helpers/getApiData'

export type LocationBasedFactorType = {
    id: number
    name: string
}

// Module-level ref shared by the global state — allows preloading before the composable is first used
const _locationBasedFactorTypes = ref<LocationBasedFactorType[]>([])

// When true, onMounted defers to let bootstrap provide the data
let _deferFetch = false

/**
 * Pre-populate emission factor types from a bootstrap response.
 * Call before the composable mounts to prevent the standalone API call.
 */
export function preloadLocationBasedFactorTypes(data: LocationBasedFactorType[]) {
    _locationBasedFactorTypes.value = data
    _deferFetch = false
}

export function setFactorTypesFetchDeferred(deferred: boolean) {
    _deferFetch = deferred
}

export const useLocationBasedFactorTypes = createGlobalState(
    () => {
        onMounted(async () => {
            // Skip if already loaded (global state persists across mounts, or preloaded from bootstrap)
            if (_locationBasedFactorTypes.value.length > 0 || _deferFetch) {
                return
            }
            const response = await fetchApiData<{ data: { data: LocationBasedFactorType[] } }>(GET_LOCATION_BASED_FACTOR_TYPES(), {
                sort_by: 'id',
                order_by: 'asc',
            })

            _locationBasedFactorTypes.value = response.data?.data.data ?? []
        })

        return _locationBasedFactorTypes
    },
)
